// ADR 30.9.26s §3 — a destination that is reserved but not yet shipped.
//
// One drawing for the rail, the sidebar and the bar. Each lays an item out
// differently, so the caller hands over its own item classes (`className`) and
// its label classes (`labelClassName`, the bar's `truncate`); this file owns
// only what the three share: the role, the accessible name, the muting and the
// "Soon" badge. The type-scale classes therefore stay in the drawings, where
// `typeScale.test.ts` polices them.
//
// `role="link"`, not a bare `<span>`: the generic role prohibits `aria-label`
// and does not support `aria-disabled`, so neither would reach a screen reader.
// Not a disabled `<button>` either — a button in a list of links announces an
// action this item will never have. No `href` and no `tabIndex`: keyboard users
// skip it, as they skip the web's other disabled controls.

import { useTranslation } from 'react-i18next'

import { Icon } from '../../ui/icons'
import type { Destination } from './destinations'

export function SoonNavItem({
  item,
  className,
  labelClassName = '',
}: {
  item: Destination
  className: string
  labelClassName?: string
}) {
  const { t } = useTranslation()
  const label = t(item.labelKey)
  return (
    <span
      role="link"
      aria-disabled="true"
      aria-label={t('admin_nav_soon_a11y', { 0: label })}
      title={label}
      className={`${className} cursor-default text-ink-muted`}
    >
      <span aria-hidden="true" className="flex h-8 items-center justify-center">
        <Icon name={item.icon} />
      </span>
      <span aria-hidden="true" className={labelClassName}>
        {label}
      </span>
      <span aria-hidden="true" className="text-label-sm">
        {t('admin_nav_soon')}
      </span>
    </span>
  )
}
